import TextInput, { TextInputProps } from '../TextInput'

const Search = (props: TextInputProps) => (
  <TextInput
    variant="simple"
    icon={['far', 'times']}
    iconColor="blue1"
    placeholder="search_lbl"
    height={40}
    onClickIcon={() =>
      props.onChange?.({
        name: props.name,
        target: {
          value: '',
        },
      })
    }
    {...props}
  />
)

export default Search
